// Mock Images - URLs de imagens reais para visualização do portfolio
// Todas as imagens são de Unsplash (uso livre)

export const mockClientLogos = {
  'Nova Era Educação': 'https://images.unsplash.com/photo-1546410531-bb4caa6b424d?w=200&h=200&fit=crop',
  'EcoRide Brasil': 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=200&h=200&fit=crop',
  'Stone': 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=200&h=200&fit=crop',
  'Petrobras': 'https://images.unsplash.com/photo-1582719471384-894fbb16e074?w=200&h=200&fit=crop',
  'Vale': 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=200&h=200&fit=crop',
  'Bradesco': 'https://images.unsplash.com/photo-1560472355-536de3962603?w=200&h=200&fit=crop',
  'Magalu': 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=200&h=200&fit=crop',
  'Ambev': 'https://images.unsplash.com/photo-1608270586620-248524c67de9?w=200&h=200&fit=crop',
  'Natura': 'https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=200&h=200&fit=crop',
  'Globo': 'https://images.unsplash.com/photo-1495020689067-958852a7765e?w=200&h=200&fit=crop',
  'JBS': 'https://images.unsplash.com/photo-1607623814075-e51df1bdc82f?w=200&h=200&fit=crop',
  'Rio Turismo': 'https://images.unsplash.com/photo-1483729558449-99ef09a8c325?w=200&h=200&fit=crop',
  'Rock in Rio': 'https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=200&h=200&fit=crop',
  'MAM': 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=200&h=200&fit=crop',
  'Editora Cidade': 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=200&h=200&fit=crop',
  'Arte Hoje': 'https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?w=200&h=200&fit=crop',
};

export const mockProjectCovers = {
  'nova-era-branding': 'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800&h=600&fit=crop',
  'ecoride-app-design': 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&h=600&fit=crop',
  'verao-stone': 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&h=600&fit=crop',
  'motion-editorial': 'https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?w=800&h=600&fit=crop',
  'ilustracoes-personalizadas': 'https://images.unsplash.com/photo-1578301978693-85fa9c0320b9?w=800&h=600&fit=crop',
};

export const mockTestimonialAvatars = {
  'Ana Silva': 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop',
  'Carlos Mendes': 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop',
  'Marina Costa': 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop',
  'Roberto Santos': 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop',
};

// Fallback genérico para imagens não encontradas
export const fallbackImages = {
  logo: 'https://images.unsplash.com/photo-1611532736597-de2d4265fba3?w=200&h=200&fit=crop',
  project: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800&h=600&fit=crop',
  avatar: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=150&h=150&fit=crop',
};

// Helper para obter URL da imagem com fallback
export const getClientLogo = (clientName: string): string => {
  return mockClientLogos[clientName as keyof typeof mockClientLogos] || fallbackImages.logo;
};

export const getProjectCover = (slug: string): string => {
  return mockProjectCovers[slug as keyof typeof mockProjectCovers] || fallbackImages.project;
};

export const getTestimonialAvatar = (name: string): string => {
  return mockTestimonialAvatars[name as keyof typeof mockTestimonialAvatars] || fallbackImages.avatar;
};

// Verificar se URL é válida (inclui caminhos relativos do public)
export const isValidImageUrl = (url: string | null | undefined): boolean => {
  if (!url) return false;
  return url.startsWith('http://') || url.startsWith('https://') || url.startsWith('/');
};

// Obter imagem com fallback automático
export const getImageWithFallback = (url: string | null | undefined, fallback: string): string => {
  if (isValidImageUrl(url)) return url!;
  return fallback;
};
